import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET } from '../api';
import { SixdeeCRBTAPI } from '../sixdeecrbtapi';
import { SignupCategoriesRequest } from './signupcategoriesrequest';

export class SignupCategoriesAPI extends SixdeeCRBTAPI<SignupCategoriesRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        return "/en/app-settings.json";
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/signupcategories/signupcategoriesapi.tsx